import type { WalkthroughEvent } from '@shared-types/frontend-scenario-definition';
import participantViewWalkthrough from './participant-view-walkthrough';
import adminViewWalkthrough from './admin-view-walkthrough';
import participantActivityWalkthrough from './participant-activity-walkthrough';
import participantReportWalkthrough from './participant-report-walkthrough';

const walkthroughs = {
    participantViewWalkthrough,
    participantActivityWalkthrough,
    participantReportWalkthrough,
    adminViewWalkthrough,
};

export const walkthroughEvents: Record<string, WalkthroughEvent> = Object.fromEntries(
    Object.entries(walkthroughs).map(([_, value]) => [value.key, value]),
);
